import { render, staticRenderFns } from "./contacts-info-tab.vue?vue&type=template&id=8d325fe4&scoped=true"
import script from "./contacts-info-tab.vue?vue&type=script&lang=js"
export * from "./contacts-info-tab.vue?vue&type=script&lang=js"
import style0 from "./contacts-info-tab.vue?vue&type=style&index=0&id=8d325fe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d325fe4",
  null
  
)

export default component.exports